<template>


     <tq-loader-container  class="TQ_center" :p_show-loader_b="!server_questBody_c || !server_teamStatus_c" :p_tq-loader_b="true">

          <div v-if="server_questBody_c && server_teamStatus_c">

               <tq-missions-list
                       :p_side-missions_ac="server_questBody_c.qb_listMissions_ac"
                       :p_team-status-missions_by-riddle-id_c="server_ts_listMissions_byRiddleId_c"
                       :p_display_lang-code_e="co_displayLangCode_e"

                       :p_missions-groups_ac="server_questBody_c.qb_missionsGroup_ac"
                       :p_team-status_c="server_teamStatus_c"
                       :p_game-status_c="server_gameStatus_c"

                       :p_support_mission-groups_b="server_questBody_c.qb_metadata_c.qbm_listMissions_supportMissionsGroups_b"
                       :p_support_mission-groups-level_b="server_questBody_c.qb_metadata_c.qbm_listMissions_supportMissionsGroupsLevels_b"
                       :p_support-points_b="server_questBody_c.qb_metadata_c.qbm_missions_supportMissionsPoints_b"

                       :pp_window-size-type_e="store_system_windowSizeType_ve.val"

                       :pe_click-mission_f="m_clickMission_f"/>

               <div v-if="server_questBody_c.qb_metadata_c.qbm_quest_supportListLastMissions_b" class="TQ_maxWidth_600px TQ_center TQ_padding_4px TQ_borderBox">

                    <div class="TQ_grid_col_auto1fr TQ_grid_gap_8px TQ_bg_hover_goldLite TQ_clickable TQ_bg_white TQ_border_blue_2px" @click="m_click_lastRiddles_f">
                         <img :src="ass_img_puzzle_c" class="TQ_width_64px TQ_padding_8px TQ_grid_center"/>
                         <div class="TQ_textAlign_initial TQ_grid_center TQ_text_24px TQ_textColor_purple TQ_text_bold">
                              {{ass_strings.twoWords_lastMissions[co_displayLangCode_e]}}
                         </div>
                    </div>
               </div>
          </div>

     </tq-loader-container>


</template>

<script>
    import {store_var, store_getStateValue_vo} from "../../../store";
    import {route_moveToRoute} from "../../../router";
    import {enum_subCollection_teamStatus} from "../../../../functions/src/shareCode/Share_S_Enum";
    import TqMissionsList from "../../../components/complex/TqMissionsList";
    import {serverBig_questBody_once_fp} from "../../../scripts/Server/S_ServerFirestore";
    import {
        serverOngoing_gameStatus_vl_set_f,
        serverOngoing_teamStatus_subCollection_cl_get_f,
        serverOngoing_teamStatus_subCollection_cl_remove_f, serverOngoing_teamStatus_vl_set_f
    } from "../../../scripts/Server/S_ServerOngoing";
    import {
        enum_moveToOptions,
        enum_urlParams
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import TqLoaderContainer from "../../../components/basic/TqLoaderContainer";
    import TqCard from "../../../components/basic/TqCard";
    import {
        ass_img_puzzle_c,
    } from "../../../assets/scripts/Ass_Files";
    import TqMissionsList_row from "../../../components/complex/TqMissionsList_row";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";

    export default {
        name: "v_Ongoing_Missions_List",
        components: {
            TqMissionsList_row,
            TqCard,
            TqLoaderContainer,
            TqMissionsList,
        },
        data() {
            return {

                // store
                store_questEvent_c                : store_getStateValue_vo(store_var.ongoing_questEvent).val,
                store_currentTeamId_uid           : store_getStateValue_vo(store_var.ongoing_currentTeamId_uid).val,
                store_system_langCode_v           : store_getStateValue_vo(store_var.system_langCode),
                store_system_windowSizeType_ve    : store_getStateValue_vo(store_var.system_windowSizeType_e),

                // server
                server_ts_listMissions_byRiddleId_c : {},
                server_questBody_c                  : undefined,
                server_gameStatus_c                 : undefined,
                server_teamStatus_c                 : undefined,

                // import
                ass_img_puzzle_c : ass_img_puzzle_c,
                ass_strings : ass_strings,

            }
        },
        computed:{
            co_displayLangCode_e(){
                return this.server_questBody_c.cm_qb_getDisplayLangCode_e(this.store_system_langCode_v.val)
            }
        },
        methods: {
            m_clickMission_f(riddleId_n) {
                route_moveToRoute(enum_moveToOptions.ongoing_Missions_Item, {[enum_urlParams.missionRiddleId_n]: riddleId_n})
            },
            m_click_lastRiddles_f(){
                route_moveToRoute(enum_moveToOptions.ongoing_Missions_Last)
            }
        },

        // life circle
        created(){

            // 1) teamStatus subCollection missions riddles
            serverOngoing_teamStatus_subCollection_cl_get_f({
                viewName_s          : this.$options.name,
                subCollectionName_e : enum_subCollection_teamStatus.LIST_MISSIONS,
                questEvent_c        : this.store_questEvent_c,
                teamId_uid          : this.store_currentTeamId_uid,
                cb_ChildAdded_f : (riddleStatus_c) => {
                    this.$set(this.server_ts_listMissions_byRiddleId_c, riddleStatus_c.rs_riddleId_n, riddleStatus_c)
                },
            })

            // 2) get questBody
            serverBig_questBody_once_fp(this.store_questEvent_c.qev_questType_e, this.store_questEvent_c.qev_questId_uid, false, true, (questBody_c)=>{
                this.server_questBody_c = questBody_c
            })


            // 3) game status
            serverOngoing_gameStatus_vl_set_f(this.$options.name, this.store_questEvent_c.qev_questType_e, this.store_questEvent_c.qev_questId_uid, this.store_questEvent_c.qev_eventId_uid, true, (gameStatus_c)=>{
                this.server_gameStatus_c = gameStatus_c
            })

            // 4) get team status
            serverOngoing_teamStatus_vl_set_f({
                viewName_s: this.$options.name, 
                questEvent_c : this.store_questEvent_c, 
                teamId_uid : this.store_currentTeamId_uid,
                cb_f: (teamStatus_c) => {
                    this.server_teamStatus_c = teamStatus_c
                }
            })

        },
        destroyed(){

            // 1) teamStatus subCollection missions riddles
            serverOngoing_teamStatus_subCollection_cl_remove_f({
                viewName_s          : this.$options.name,
                subCollectionName_e : enum_subCollection_teamStatus.LIST_MISSIONS,
                questEvent_c        : this.store_questEvent_c,
                teamId_uid          : this.store_currentTeamId_uid,
            })
        }

    }

</script>

<style scoped lang="scss">
     .lc_lastRiddleBtn{
          position: absolute;
          bottom: 100px;
          left: 8px;
     }
</style>